var newsList = {
	noResults: "No results found",
	readMore: "More",
	estimatedReadingTime: "~{minutes} min read"
};
var en = {
	newsList: newsList
};

export { en as default, newsList };
